<form [formGroup]="berekeningBox1FormGroup">
    <div formGroupName="box1">
        <div formGroupName="opbouwInkomen">
            <div
                    *ngIf="berekeningBox1.box1?.opbouwInkomen?.negatievePersoonsgebondenAftrek !== undefined">
                <div class="row">
                    <div class="col col-1">
                        <p>Negatieve persoonsgebonden aftrek</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="negatievePersoonsgebondenAftrek"
                                id="negatievePersoonsgebondenAftrek"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </div>
</form>
